
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 23","stroke":"#221B38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.476 4.037l-.325-2.575A.524.524 0 0012.625 1H9.357c-.263 0-.494.2-.526.462l-.284 2.26a.516.516 0 01-.336.42 7.645 7.645 0 00-2.449 1.482L3.366 4.615a.527.527 0 00-.662.221l-1.64 2.838a.537.537 0 00.148.683l2.07 1.566a7.875 7.875 0 00-.01 3.173h.01l-2.07 1.566a.523.523 0 00-.137.683l1.64 2.838c.136.231.42.326.662.22l2.396-1.008-.01.01c.388.347.83.662 1.303.936.473.273.956.494 1.46.662v-.021l.326 2.575c.01.262.242.462.505.462h3.279a.54.54 0 00.525-.462l.284-2.26a.516.516 0 01.336-.42 7.645 7.645 0 002.449-1.482l2.396 1.009c.242.105.525.01.662-.221l1.64-2.838a.523.523 0 00-.137-.683l-2.07-1.566c.22-1.061.22-2.143.01-3.173h-.01l2.049-1.566a.523.523 0 00.137-.683l-1.64-2.838a.527.527 0 00-.662-.22l-2.386 1.008.01-.01a7.907 7.907 0 00-1.302-.936 7.903 7.903 0 00-1.461-.662","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.996 15.713a4.204 4.204 0 100-8.408 4.204 4.204 0 000 8.408z","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    